import { Injectable } from '@angular/core';
import { RestCallService } from '../../../../core/services/rest-call/rest-call.service';
import { HttpClient } from '@angular/common/http';
import { TranslateApplicationService } from '../../../../core/translate/translate-application-service';
import { ToastrService } from 'ngx-toastr';
import { NotificationService } from 'src/app/core/services/notification/notification.service';
import { CognitoService } from 'src/app/core/services/cognito/cognito.service';
import { IApproversAreas } from '../Interfaces/IApproversAreas';
import { IVisitorsByVisit } from '../Interfaces/IVisitorsByVisit';
import { IVisitors } from '../Interfaces/IVisitors';
import { IVisitorApprovalHistory } from '../Interfaces/IVisitorApprovalHistory';


@Injectable({
  providedIn: 'root',
})
export class ApproversAreasService extends RestCallService {
  public dataToSend: IApproversAreas = {
    pkapproverarea: 0,
    approverarea: '',
    fksite: 0,
    creationdate: new Date(),
    strcreationdate: '',
    fkemployeecreator: 0,
    employeecreatorname: '',
    lastupdated: new Date(),
    strlastupdated: '',
    fkemployeeupdater: 0,
    employeeupdatername: '',
    available: false,
    username: '',
    pkvisit: 0,
    employeename: '',
    email: '',
    inprogress: false
  }

  dataVisitorByVisit: IVisitorsByVisit = {
    pkvisitorbyvisit: 0,
    visittype: '',
    activities: '',
    visitorname: '',
    startDate: new Date(),
    strStartDate: '',
    sponsorname: '',
    endDate: new Date(),
    strEndDate: '',
    site: '',
    startHour: '',
    building: '',
    endHour: '',
    area: '',
    idphoto: '',
    equipment: false,
    vehicle: false,
    pkVisit: 0,
    pkVisitor: 0,
    fksite: 0,
    approvalArea: '',
    approvalType: '',
    fkbuilding: 0,
    fkrecordstatus: 0,
    recordstatus: ''
  }

  resultCreate: any;

  constructor(
    public httpClient: HttpClient,
    private cognitoService: CognitoService,
    public toastr: ToastrService,
    public notificationService: NotificationService,
    public translate: TranslateApplicationService,
  ) {
    super(httpClient, 'JACSapi', toastr, notificationService, translate);
  }

  public GetList() {
		if (!this.cognitoService.IsAuhtenticated())
      this.cognitoService.LogOut();
    this.dataToSend.fksite = Number(window.localStorage.getItem("pksite"));
		return this.post<IApproversAreas[]>('/api/ApproversAreas/GetApproversAreas', this.dataToSend);
  }

  public GetApproversAreasByVisitorByVisit(pkvisit: number) {
		if (!this.cognitoService.IsAuhtenticated())
       this.cognitoService.LogOut();
    this.dataToSend.pkvisit = pkvisit;
    this.dataToSend.fksite = Number(window.localStorage.getItem("pksite"));
		return this.post<IApproversAreas[]>('/api/ApproversAreas/GetApproversAreasByVisitorByVisit', this.dataToSend);
  }

  public GetStatusApprovalsVisitorsByVisit(pkvisit: number, approvalType: string) {
    
    this.dataVisitorByVisit.fksite = Number(window.localStorage.getItem("pksite"));
    this.dataVisitorByVisit.approvalArea = approvalType;
    this.dataVisitorByVisit.pkVisit = pkvisit;
    return this.post<IVisitorApprovalHistory[]>(
      '/api/ApproversAreas/GetStatusApprovalsVisitorsByVisit',
      this.dataVisitorByVisit
    );
  }

  public GetApproversByBuilding(fkbuilding: number, approvalType: string) {
    
    this.dataVisitorByVisit.fksite = Number(window.localStorage.getItem("pksite"));
    this.dataVisitorByVisit.fkbuilding = fkbuilding;
    this.dataVisitorByVisit.approvalType = approvalType;
  
    return this.post<IApproversAreas[]>(
      '/api/ApproversAreas/GetApproversByBuilding',
      this.dataVisitorByVisit
    );
  }
}